exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":root {\n  --green: #2BB772;\n  --blue: #3274D6;\n}\n\nbody {\n  font-family: 'Roboto', sans-serif;\n  background-color: #fff;\n  color: #333;\n}\na {\n  color: #72a0e3;\n}\n.link:hover {\n  background-color: #e8f0fc;\n}\n\n.t-mb {\n  font-weight: 500;\n}\n.t-bold {\n  font-weight: 700;\n}\n\n.t-center {\n  text-align: center;\n}\n.t-small {\n  font-size: 0.8rem;\n}\n.t-medium {\n  font-size: 1.3rem\n}\n.t-large {\n  font-size: 1.8rem;\n}\n.t-xxl {\n  font-size: 3.8rem;\n}\n\n.icon-xs {\n  width: 13px;\n  height: 13px;\n}\n\n.icon-md {\n  width: 32px;\n  height: 32px;\n}\n\n.icon-middle {\n  vertical-align: middle;\n}\n\n.green {\n  color: var(--green);\n}\n.blue {\n  color: var(--blue);\n}\n\n.container-centered {\n  max-width: 980px;\n  margin: 0 auto;\n}\n\n._5COBev5SpL2RYXee9lI6_ {\n  height: 4rem;\n  line-height: 4rem;\n}\n\n.mIO0VDI4b9F-D6PZv0_1o {\n  margin-top: 4rem;\n}\n", ""]);

// exports
exports.locals = {
	"appHeader": "_5COBev5SpL2RYXee9lI6_",
	"appContent": "mIO0VDI4b9F-D6PZv0_1o"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1}!./src/styles/site.css
// module id = 121
// module chunks = 0